import React from "react";
import { Link } from "react-router-dom";
import banner from "../../assets/images/banner.jpg";

function ServicesHomeTwo({ className }) {
  return (
    <>
      <section
        className={`appie-services-2-area pb-100 ${className}`}
        id="service"
      >
        <div className="container">
          <div className="row align-items-end">
            <img src={banner} alt="" />
          </div>
          <div className="row text-center">
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <Link className="icon" to="/sports/football">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/football">
                  <h4 className="title">Football</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <Link className="icon" to="/sports/turf-cricket-boys">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/turf-cricket-boys">
                  <h4 className="title">Turf Cricket (Boys)</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-3 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms"
              >
                <Link className="icon" to="/sports/turf-cricket-girls">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/turf-cricket-girls">
                  <h4 className="title">Turf Cricket (Girls)</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-4 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <Link className="icon" to="/sports/volleyball">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/volleyball">
                  <h4 className="title">Volleyball</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-5 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <Link className="icon" to="/sports/basketball">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/basketball">
                  <h4 className="title">Basketball</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-6 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms"
              >
                <Link className="icon" to="/sports/snooker">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/snooker">
                  <h4 className="title">Snooker</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <Link className="icon" to="/sports/squash">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/squash">
                  <h4 className="title">Squash</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <Link className="icon" to="/sports/lawn-tennis">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/lawn-tennis">
                  <h4 className="title">Lawn Tennis</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-3 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms"
              >
                <Link className="icon" to="/sports/table-tennis">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/table-tennis">
                  <h4 className="title">Table Tennis</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-4 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <Link className="icon" to="/sports/badminton">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/badminton">
                  <h4 className="title">Badminton</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-5 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <Link className="icon" to="/sports/chess">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/chess">
                  <h4 className="title">Chess</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-6 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms"
              >
                <Link className="icon" to="/sports/carrom">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/carrom">
                  <h4 className="title">Carrom</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <Link className="icon" to="/sports/swimming">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/swimming">
                  <h4 className="title">Swimming</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-2 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <Link className="icon" to="/sports/sprint">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/sprint">
                  <h4 className="title">Sprint</h4>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="appie-single-service-2 item-3 mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms"
              >
                <Link className="icon" to="/sports/throw-ball">
                  <i className="fas fa-bolt" />
                </Link>
                <br />
                <Link className="icon" to="/sports/throw-ball">
                  <h4 className="title">Throwball</h4>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServicesHomeTwo;
